// removed by extract-text-webpack-plugin
module.exports = {"fa":"index__fa___2G8xb","fa-linkedin":"index__fa-linkedin___XRg9G","fa-github":"index__fa-github___1LUOy","fa-facebook":"index__fa-facebook___48yv_","fa-twitter":"index__fa-twitter___x_r-9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Icon/index.less
 ** module id = 202
 ** module chunks = 0
 **/